import { useState } from "react";
import Modal from "./modal"

export default function JobForm({ editData, onUpdate }) {
    const [open, setOpen] = useState(false);
  const [job, setJob] = useState(editData || {
    position: "",
    location: "",
    type: "",
    department:"",
    responsibilities: "",
    requirements: "",
    skills: ""
  });

  const handleChange = e =>
    setJob({ ...job, [e.target.name]: e.target.value });

  const submit = async () => {
    await fetch("https://arkane.in/apijob/create.php", {
      method: "POST",
      body: JSON.stringify(job)
    });
    window.location.reload();
  };

  return (

     <>
     <button onClick={() => setOpen(true)} className="primary-button full-width-mobile w-button">Add Job</button>

      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <h3>Add New Job Opening CRM</h3>
<div className="form-controller">
        <div className="form-gap">
           <div className="from-gap-col">
              <input className="form-control contacts-input" name="position" placeholder="Job Title" onChange={handleChange} />
              <input className="form-control contacts-input" name="location" placeholder="Location" onChange={handleChange} />
              <input className="form-control contacts-input" name="type" placeholder="Job Type" onChange={handleChange} />
               <input className="form-control contacts-input" name="department" placeholder="Department/Team" onChange={handleChange} />
           </div>
           <div className="from-gap-col">
              <textarea className="form-control contacts-input" name="requirements" placeholder="Job Description" onChange={handleChange} />
              <textarea className="form-control contacts-input" name="responsibilities" placeholder="Key Responsibilities" onChange={handleChange} />
              
              <textarea className="form-control contacts-input" name="skills" placeholder="Required Skills" onChange={handleChange} />
           </div>
      
      <button onClick={submit} className="primary-button full-width-mobile w-button">Save Job</button>
        </div>
    </div>
      </Modal>
    
     </>
  );
}
